import { render, staticRenderFns } from "./overseasbasecost-setting-add.vue?vue&type=template&id=34125420&"
import script from "./overseasbasecost-setting-add.vue?vue&type=script&lang=ts&"
export * from "./overseasbasecost-setting-add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports